/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['skins.core.GooglePlusOneSkin'] = {
  "react": [
    [
      "div",
      "googlePlus",
      [],
      {}
    ]
  ],
  "params": {
    "tdr": "URL"
  },
  "paramsDefaults": {
    "tdr": "BASE_THEME_DIRECTORY"
  },
  "css": {
    "%[data-state~=\"small_bubble\"]": "background:url([tdr]google-plus-small-bubble.png) no-repeat;",
    "%[data-state~=\"small_none\"]": "background:url([tdr]google-plus-small-none.png) no-repeat;",
    "%[data-state~=\"small_inline\"]": "background:url([tdr]google-plus-small-inline.png) no-repeat;",
    "%[data-state~=\"medium_bubble\"]": "background:url([tdr]google-plus-medium-bubble.png) no-repeat;",
    "%[data-state~=\"medium_none\"]": "background:url([tdr]google-plus-medium-none.png) no-repeat;",
    "%[data-state~=\"medium_inline\"]": "background:url([tdr]google-plus-medium-inline.png) no-repeat;",
    "%[data-state~=\"standard_bubble\"]": "background:url([tdr]google-plus-standard-bubble.png) no-repeat;",
    "%[data-state~=\"standard_none\"]": "background:url([tdr]google-plus-standard-none.png) no-repeat;",
    "%[data-state~=\"standard_inline\"]": "background:url([tdr]google-plus-standard-inline.png) no-repeat;",
    "%[data-state~=\"tall_bubble\"]": "background:url([tdr]google-plus-tall-bubble.png) no-repeat;",
    "%[data-state~=\"tall_none\"]": "background:url([tdr]google-plus-tall-none.png) no-repeat;",
    "%[data-state~=\"tall_inline\"]": "background:url([tdr]google-plus-tall-inline.png) no-repeat;"
  }
}

    return skins;
});
